import { useState } from 'react';
import { useOutletContext } from 'react-router-dom';
import { SUMMARY_BUILDERS } from './helper';
import Summary from './Summary';

const Gate = ({ stepId, children }) => {
  const { sectionData, completion, mergeSection }: any = useOutletContext() || {};
  const [isEditing, setIsEditing] = useState(false);
  // "Add insurance" has to reach the form, or it opens on whatever state the
  // patient was already in — the screen they just clicked away from.
  const [addInsurance, setAddInsurance] = useState(false);

  const stopEditing = () => {
    setIsEditing(false);
    setAddInsurance(false);
  };

  const isCompleted = !!completion?.[stepId];

  if (SUMMARY_BUILDERS[stepId] && isCompleted && !isEditing)
    return (
      <Summary
        stepId={stepId}
        data={sectionData?.[stepId]}
        onEdit={(intent: any = null) => {
          setAddInsurance(!!intent?.addInsurance);
          setIsEditing(true);
        }}
      />
    );

  if (!isEditing) return children({});

  return children({
    editMode: true,
    addInsurance,
    onCancel: stopEditing,
    onSaved: (data) => {
      mergeSection(stepId, data);
      stopEditing();
    },
  });
};

export default Gate;
